<div class="kw-page" [nbSpinner]="this.isLoading">

  <button mat-button class="back-btn" type="button" (click)="this.location.back()">
    <fa-icon [icon]="faArrowLeft" class="me-2"></fa-icon>Back
  </button>

  <div class="kw-page-header">
    <div>
      <h1 class="page-title">Transfer Inventory</h1>
      <div class="page-subtitle">Move quantities from one handling unit to another.</div>
    </div>
  </div>

  <div class="transfer" *ngIf="this.hum">

    <!-- SOURCE -->
    <section class="unit-card source" aria-labelledby="sourceRole">
      <div class="unit-head">
        <div class="unit-avatar"><fa-icon [icon]="faBox"></fa-icon></div>
        <div class="unit-info">
          <div class="unit-role" id="sourceRole">Source</div>
          <div class="unit-barcode">{{this.hum.barcode}}</div>
          <div class="unit-meta">
            <span *ngIf="getLocation(this.hum)">
              <fa-icon [icon]="faLocationDot" class="meta-icon"></fa-icon>{{getLocation(this.hum)}}
            </span>
            <span>{{itemCount(this.hum)}}</span>
          </div>
        </div>
      </div>

      <table class="transfer-table">
        <thead>
          <tr>
            <th>{{"Product" | tenantWords}}</th>
            <th>Variety</th>
            <th *ngFor="let name of this.attributeNames">{{name}}</th>
            <th class="num">Avail.</th>
            <th class="num">Transfer</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let hud of this.hum.handlingUnitDetails; trackBy: trackByHud">
            <td class="product-cell">
              <div class="item-name">{{hud.itemName}}</div>
              <div class="item-sub">{{"Lot" | tenantWords}} {{hud.lotNumber}}</div>
              <div class="item-sub mobile-only">{{describe(hud)}}</div>
            </td>
            <td class="desktop-only">{{hud.varietyName}}</td>
            <td class="desktop-only" *ngFor="let name of this.attributeNames; let i = index">
              {{hud.itemAttributeValues?.[i]?.value}}
            </td>
            <td class="num desktop-only">{{hud.quantity | number}}</td>
            <td class="num qty-cell">
              <ng-container *ngIf="hud.packageHasComponents; else plainQty">
                <label class="qty-label">
                  {{hud.packageUnitOfMeasure | titlecase}}
                  <input class="qty-input" type="number" min="0" [(ngModel)]="hud.transferPackageQty"
                    [class.filled]="hud.transferPackageQty" (ngModelChange)="setQty(hud)" placeholder="0">
                </label>
                <label class="qty-label">
                  {{hud.packageComponentName | titlecase}}
                  <input class="qty-input" type="number" min="0" [(ngModel)]="hud.transferComponentQty"
                    [class.filled]="hud.transferComponentQty" (ngModelChange)="setQty(hud)" placeholder="0">
                </label>
              </ng-container>
              <ng-template #plainQty>
                <input class="qty-input" type="number" min="0" [(ngModel)]="hud.transferQty"
                  [class.filled]="hud.transferQty" (ngModelChange)="setQty(hud)" placeholder="0"
                  [attr.aria-label]="'Qty to transfer for ' + hud.itemName + ' lot ' + hud.lotNumber">
              </ng-template>
              <div class="qty-of">of {{hud.quantity | number}}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <div class="flow" aria-hidden="true">
      <span class="flow-dot"><fa-icon [icon]="faArrowRight"></fa-icon></span>
    </div>

    <!-- DESTINATION -->
    <section class="unit-card destination" aria-labelledby="destinationRole">
      <div class="unit-head">
        <div class="unit-avatar"><fa-icon [icon]="faBox"></fa-icon></div>
        <div class="unit-info">
          <div class="unit-role" id="destinationRole">Destination</div>
          <ng-container *ngIf="this.destinationHum; else noDestinationTitle">
            <div class="unit-barcode">{{this.destinationHum.barcode}}</div>
            <div class="unit-meta">
              <span *ngIf="getLocation(this.destinationHum)">
                <fa-icon [icon]="faLocationDot" class="meta-icon"></fa-icon>{{getLocation(this.destinationHum)}}
              </span>
              <span>{{itemCount(this.destinationHum)}}</span>
            </div>
          </ng-container>
          <ng-template #noDestinationTitle>
            <div class="unit-barcode muted">Not selected</div>
          </ng-template>
        </div>
        <button *ngIf="this.destinationHum" mat-stroked-button type="button" (click)="scan()">
          <fa-icon [icon]="faBarcode" class="me-2"></fa-icon>Rescan
        </button>
      </div>

      <table class="transfer-table" *ngIf="this.destinationHum; else noDestination">
        <thead>
          <tr>
            <th>{{"Product" | tenantWords}}</th>
            <th>Variety</th>
            <th *ngFor="let name of this.attributeNames">{{name}}</th>
            <th class="num">Current</th>
            <th class="num">After</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of this.preview; trackBy: trackByPreview">
            <td class="product-cell">
              <div class="item-name">{{row.hud.itemName}}<span class="new-pill" *ngIf="row.current === null">New</span></div>
              <div class="item-sub">{{"Lot" | tenantWords}} {{row.hud.lotNumber}}</div>
              <div class="item-sub mobile-only">{{describe(row.hud)}}</div>
            </td>
            <td class="desktop-only">{{row.hud.varietyName}}</td>
            <td class="desktop-only" *ngFor="let name of this.attributeNames; let i = index">
              {{row.hud.itemAttributeValues?.[i]?.value}}
            </td>
            <td class="num desktop-only">{{row.current === null ? '—' : (row.current | number)}}</td>
            <td class="num after-cell">
              <span class="after">{{row.after | number}}</span>
              <span class="delta" *ngIf="row.delta">+{{row.delta | number}}</span>
            </td>
          </tr>
        </tbody>
      </table>

      <ng-template #noDestination>
        <div class="empty-destination">
          <div class="empty-icon"><fa-icon [icon]="faBarcode"></fa-icon></div>
          <h3>Scan the destination unit</h3>
          <p>Scan or type the barcode of the handling unit that will receive this inventory.</p>
          <button mat-raised-button color="primary" type="button" (click)="scan()">
            <fa-icon [icon]="faBarcode" class="me-2"></fa-icon>Scan Destination
          </button>
        </div>
      </ng-template>
    </section>

  </div>

  <div class="action-bar" *ngIf="this.hum">
    <div class="action-summary">{{this.summary}}</div>
    <button mat-stroked-button type="button" (click)="this.location.back()">Cancel</button>
    <button mat-raised-button color="primary" type="button" [disabled]="!this.canComplete" (click)="save()">
      <fa-icon [icon]="faCheck" class="me-2"></fa-icon>Complete Transfer
    </button>
  </div>

</div>
